module.exports = __webpack_public_path__ + "static/make-video-slide6@2x-8ab4f1866c89e47fc40c8277624c9d3e.png";